//https://stackoverflow.com/a/2901298/8724367
export const toNumberWithCommas = (value: number): string => {
  return value.toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
